import React from "react";
import { UIText } from "@pfs/react-ui-kit";
import { useTranslation } from "src/hooks/useTranslation";
import { TEXT_TAGS } from "src/utils/enums";
import "./MastercardDisclaimer.scss";

const TERMS_URL =
  "https://www.passportcard.co.il/financial-services/terms-of-use/";
const RATES_URL =
  "https://www.passportcard.co.il/financial-services/service-rates-agreement/";

export interface MastercardDisclaimerProps {
  textClassName?: string;
}

const MastercardDisclaimer: React.FC<MastercardDisclaimerProps> = ({
  textClassName,
}) => {
  const { t } = useTranslation();

  return (
    <UIText
      text={
        <>
          {t("eligibleWebsites.mastercardDisclaimerPrefix")}
          <a
            href={TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mastercard-disclaimer__link"
          >
            {t("eligibleWebsites.mastercardDisclaimerTermsLink")}
          </a>
          {t("eligibleWebsites.mastercardDisclaimerMiddle")}
          <a
            href={RATES_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mastercard-disclaimer__link"
          >
            {t("eligibleWebsites.mastercardDisclaimerRatesLink")}
          </a>
          {t("eligibleWebsites.mastercardDisclaimerSuffix")}
        </>
      }
      tag={TEXT_TAGS.P}
      size={12}
      weight={400}
      style={textClassName}
    />
  );
};

export default MastercardDisclaimer;
